/* ============================================================
   VENALESS - theme.js
   ES5 estricto (T4.15 / MC 14): function() clasico y var en todo el archivo.
   Fuera del baseline y por lo tanto ausentes: arrow functions, optional chaining,
   nullish coalescing, async/await, el metodo closest del DOM y el forEach de NodeList.
   Los reemplazos estan abajo, en el bloque de utilidades.

   Inventario CERRADO del core (T5.16 / T6.1): galeria, form de producto,
   ATC AJAX, sticky ATC, cart drawer, menu y buscador, mini-carrusel, timeline,
   CTA intermedio, mostrar mas resenas, popup, back-to-top, alerta de stock,
   countdown (T7.16), videos con sonido al tocar y reveal.
   Por debajo de ~25 secciones no existe sections-lab.js: todo vive aca (T5.16).
   ============================================================ */
(function () {
  'use strict';

  var NS = (window.VenalessTheme = window.VenalessTheme || {});
  var ROUTES = window.VenalessRoutes || {};

  /* ---------- utilidades ES5 ---------- */

  // Reemplazo ES5 del metodo closest del DOM, que no esta en el baseline (T4.15).
  function closestAttr(el, attr) {
    while (el && el.nodeType === 1) {
      if (el.hasAttribute(attr)) return el;
      el = el.parentNode;
    }
    return null;
  }

  function each(list, fn) {
    if (!list) return;
    for (var i = 0; i < list.length; i++) fn(list[i], i);
  }

  function qsa(scope, sel) {
    return (scope || document).querySelectorAll(sel);
  }

  // Texto que viene de cart.js y se escribe con innerHTML (titulo, variante).
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // Formato de precio UNICO de la pagina (8.9.1). Espejo exacto de snippets/money.liquid:
  // con el setting "Mostrar centavos" del theme el layout marca <html data-money-decimals="true">.
  var MONEY_DECIMALS = document.documentElement.getAttribute('data-money-decimals') === 'true';
  function money(cents) {
    cents = Math.round(cents || 0);
    if (MONEY_DECIMALS) {
      var dec = cents % 100;
      return '$' + String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') +
        ',' + (dec < 10 ? '0' : '') + dec;
    }
    return '$' + String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  NS.money = money;

  // T6.9 / L-45: los drops devuelven /cart/add SIN el sufijo .js.
  function withJs(u, fallback) {
    u = u || fallback;
    return u.indexOf('.js') === -1 ? u.replace(/\/$/, '') + '.js' : u;
  }
  function cartAddUrl() { return withJs(ROUTES.cartAdd, '/cart/add'); }
  function cartChangeUrl() { return withJs(ROUTES.cartChange, '/cart/change'); }
  function cartUpdateUrl() { return withJs(ROUTES.cartUpdate, '/cart/update'); }
  function cartUrl() { return withJs(ROUTES.cart, '/cart'); }

  function setExpanded(el, open) {
    if (!el) return;
    el.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  /* ---------- 1. Galeria (T7.2 / T7.3) ---------- */

  function initGallery(scope) {
    each(qsa(scope, '[data-gallery]'), function (root) {
      if (root.getAttribute('data-lab-bound')) return;
      root.setAttribute('data-lab-bound', '1');

      var track = root.querySelector('[data-gallery-main]');
      var thumbsWrap = root.querySelector('[data-gallery-thumbs]');
      if (!track) return;

      var slides = track.children;
      var thumbs = thumbsWrap ? thumbsWrap.querySelectorAll('[data-gallery-thumb]') : [];
      var current = 0;

      // Una sola funcion de cambio de slide, reutilizada por flechas y thumbs (T7.2).
      function showSlide(idx) {
        if (!slides.length) return;
        current = ((idx % slides.length) + slides.length) % slides.length;
        track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        for (var i = 0; i < thumbs.length; i++) {
          if (i === current) {
            thumbs[i].className = thumbs[i].className.replace(/\s*is-active/g, '') + ' is-active';
            if (thumbs[i].scrollIntoView) {
              thumbs[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
            }
          } else {
            thumbs[i].className = thumbs[i].className.replace(/\s*is-active/g, '');
          }
        }
      }
      root.auronShowSlide = showSlide;

      var prev = root.querySelector('[data-gallery-prev]');
      var next = root.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { showSlide(current - 1); });
      if (next) next.addEventListener('click', function () { showSlide(current + 1); });

      each(thumbs, function (t, i) {
        t.addEventListener('click', function () { showSlide(i); });
      });

      // Sincroniza el indice cuando el gesto lo mueve el navegador (scroll-snap nativo).
      var syncTimer = null;
      track.addEventListener('scroll', function () {
        if (syncTimer) clearTimeout(syncTimer);
        syncTimer = setTimeout(function () {
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          if (idx !== current && slides[idx]) {
            current = idx;
            for (var i = 0; i < thumbs.length; i++) {
              thumbs[i].className = thumbs[i].className.replace(/\s*is-active/g, '') + (i === idx ? ' is-active' : '');
            }
          }
        }, 80);
      }, { passive: true });

      // T7.3 / T6.16 (B): drag con umbral de 4px y click suprimido en fase de CAPTURA.
      if (thumbsWrap) {
        var isDown = false, startX = 0, startScroll = 0, dragMoved = 0;

        thumbsWrap.addEventListener('mousedown', function (e) {
          isDown = true; dragMoved = 0;
          startX = e.pageX; startScroll = thumbsWrap.scrollLeft;
          thumbsWrap.className += ' is-dragging';
        });
        // Con mouse los listeners van en document a proposito (arbitraje de T7.3).
        document.addEventListener('mousemove', function (e) {
          if (!isDown) return;
          var dx = e.pageX - startX;
          if (Math.abs(dx) > dragMoved) dragMoved = Math.abs(dx);
          thumbsWrap.scrollLeft = startScroll - dx;
        });
        document.addEventListener('mouseup', function () {
          if (!isDown) return;
          isDown = false;
          thumbsWrap.className = thumbsWrap.className.replace(/\s*is-dragging/g, '');
        });
        thumbsWrap.addEventListener('click', function (e) {
          if (dragMoved > 4) { e.preventDefault(); e.stopPropagation(); dragMoved = 0; }
        }, true);
      }
    });
  }

  /* ---------- 2. Form de producto: packs, upsells, total (T7.1 / T6.14) ---------- */

  function initProductForm(scope) {
    each(qsa(scope, '[data-product-form]'), function (form) {
      if (form.getAttribute('data-lab-bound')) return;
      form.setAttribute('data-lab-bound', '1');

      var wrap = form.querySelector('[data-hp-bundles]');
      var pill = form.querySelector('[data-inst-pill]');

      function selectedLabel() {
        var radio = form.querySelector('[data-bundle]:checked');
        return radio ? closestAttr(radio, 'data-bundle-label') : null;
      }

      function emit(label) {
        if (!label) return;
        var radio = label.querySelector('[data-bundle]');
        document.dispatchEvent(new CustomEvent('bundle:selected', {
          detail: {
            variantId: radio ? radio.getAttribute('data-variant-id') : '',
            priceCents: parseInt(label.getAttribute('data-price-cents'), 10) || 0,
            compareCents: parseInt(label.getAttribute('data-compare-cents'), 10) || 0,
            variantTitle: label.getAttribute('data-variant-title') || '',
            stock: label.getAttribute('data-stock') || ''
          }
        }));
      }

      // 8.5.7 / T7.11 (d): la cuota de la pill se recalcula con el pack elegido,
      // con la misma division entera que usa el Liquid para el primer render.
      function paintInstallments(label) {
        if (!pill || !label) return;
        var amount = pill.querySelector('[data-inst-amount]');
        var n = parseInt(pill.getAttribute('data-inst-count'), 10) || 1;
        var cents = parseInt(label.getAttribute('data-price-cents'), 10) || 0;
        if (amount && cents > 0) amount.textContent = money(Math.floor(cents / n));
      }

      function paint() {
        var chosen = selectedLabel();
        // --selected es la UNICA clase que sigue al click (T6.14 / T2.23).
        each(qsa(form, '[data-bundle-label]'), function (lb) {
          lb.className = lb.className.replace(/\s*is-selected/g, '');
          if (lb === chosen) lb.className += ' is-selected';
        });
        // Solo quedan visibles los upsells del pack elegido (T7.6).
        var chosenId = chosen ? chosen.getAttribute('data-bundle-id') : '';
        each(qsa(form, '[data-bundle-upsells]'), function (box) {
          box.hidden = box.getAttribute('data-bundle-upsells') !== chosenId;
        });
        paintInstallments(chosen);
        emit(chosen);
      }

      if (wrap) {
        // Un unico listener delegado de change (7.1.8), en el form: los packs son
        // blocks y pueden quedar en mas de un grupo si el merchant los separa.
        form.addEventListener('change', function (e) {
          if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-bundle')) paint();
        });
        paint(); // estado inicial sobre el radio preseleccionado (4.8.3)
      }

      // T6.8 / L-54: preventDefault NO detiene la propagacion. Sin stopPropagation,
      // un listener delegado en document correria el mismo submit una segunda vez.
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addToCart(form);
      });
    });
  }

  /* ---------- 3. Add to cart: payload multi-item (T6.15) ---------- */

  function addToCart(form) {
    var btn = form.querySelector('[data-atc-button]');
    var label = btn ? btn.innerHTML : '';
    var items = [];

    var radio = form.querySelector('[data-bundle]:checked');
    if (radio) {
      items.push({ id: parseInt(radio.getAttribute('data-variant-id'), 10), quantity: 1 });
    } else {
      var hidden = form.querySelector('input[name="id"]');
      if (hidden) items.push({ id: parseInt(hidden.value, 10), quantity: 1 });
    }

    // Ignora los checkboxes que viven en un contenedor hidden (T6.15).
    each(qsa(form, '[data-upsell-checkbox]'), function (cb) {
      if (!cb.checked) return;
      var box = closestAttr(cb, 'data-bundle-upsells');
      if (box && box.hidden) return;
      items.push({ id: parseInt(cb.getAttribute('data-variant-id'), 10), quantity: 1 });
    });

    if (!items.length) return;

    if (btn) { btn.disabled = true; btn.innerHTML = 'Agregando...'; }

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        // T6.7 / L-53: fetch solo rechaza en errores de RED.
        if (!r.ok) throw new Error('cart-add-failed');
        return r.json();
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (NS.cart && NS.cart.added) NS.cart.added();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        // Sin AJAX el comprador sigue pudiendo comprar: cae al submit nativo (T4.8).
        form.submit();
      });
  }

  /* ---------- 4. Sticky ATC (T6.12 / T6.13 / T7.7) ---------- */

  function initStickyAtc(scope) {
    var sticky = (scope || document).querySelector('[data-sticky-atc]');
    if (!sticky || sticky.getAttribute('data-lab-bound')) return;
    sticky.setAttribute('data-lab-bound', '1');

    var mainAtcBtn = document.getElementById('AddToCartBtn');

    function show() {
      if (sticky.className.indexOf('is-visible') === -1) sticky.className += ' is-visible';
      document.body.className = document.body.className.replace(/\s*is-sticky-visible/g, '') + ' is-sticky-visible';
    }
    function hide() {
      sticky.className = sticky.className.replace(/\s*is-visible/g, '');
      document.body.className = document.body.className.replace(/\s*is-sticky-visible/g, '');
    }

    // T7.0 / MP R35: feature-detect y degradacion con sentido.
    if (mainAtcBtn && typeof IntersectionObserver !== 'undefined') {
      var obs = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          // 7.1.3: entra recien cuando el boton ya quedo ARRIBA del viewport.
          // Antes de llegar a el, el sticky duplicaria el CTA en vez de reemplazarlo.
          if (entries[i].isIntersecting || entries[i].boundingClientRect.top > 0) hide(); else show();
        }
      }, { threshold: 0 });
      obs.observe(mainAtcBtn);
    } else {
      // Fallback obligatorio: sin ATC de hero o sin observer, el sticky se ve siempre.
      show();
    }

    var nameEl = sticky.querySelector('[data-sticky-name]');
    var priceEl = sticky.querySelector('[data-sticky-price]');
    var compEl = sticky.querySelector('[data-sticky-compare]');
    var btn = sticky.querySelector('[data-atc-button]');

    function apply(d) {
      if (nameEl) nameEl.textContent = d.variantTitle || '';
      if (priceEl) priceEl.textContent = money(d.priceCents || 0);
      if (compEl) compEl.textContent = d.compareCents > d.priceCents ? money(d.compareCents) : '';
      if (btn) btn.setAttribute('data-variant-id', d.variantId || '');
    }
    document.addEventListener('bundle:selected', function (e) { apply(e.detail || {}); });

    // Estado inicial: el form pudo emitir bundle:selected ANTES de que este
    // listener existiera. Sin esta lectura el sticky arrancaba con la primera
    // variante y agregaba el pack 1 con el pack 2 preseleccionado (11.94: el
    // resultado no puede depender del orden de ejecucion de los scripts).
    var checked = document.querySelector('[data-product-form] [data-bundle]:checked');
    var label = checked ? closestAttr(checked, 'data-bundle-label') : null;
    if (label) {
      apply({
        variantId: checked.getAttribute('data-variant-id'),
        priceCents: parseInt(label.getAttribute('data-price-cents'), 10) || 0,
        compareCents: parseInt(label.getAttribute('data-compare-cents'), 10) || 0,
        variantTitle: label.getAttribute('data-variant-title') || ''
      });
    }

    // El sticky hace su PROPIO fetch: no simula un click en el boton principal (7.1.7).
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (!id) { window.location.href = ROUTES.cart || '/cart'; return; }
        var original = btn.innerHTML;
        btn.disabled = true; btn.innerHTML = 'Agregando...';
        fetch(cartAddUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('sticky-add-failed'); return r.json(); })
          .then(function () {
            btn.disabled = false; btn.innerHTML = original;
            document.dispatchEvent(new CustomEvent('cart:updated'));
            if (NS.cart && NS.cart.added) NS.cart.added();
          })
          .catch(function () {
            btn.disabled = false; btn.innerHTML = original;
            window.location.href = ROUTES.cart || '/cart';
          });
      });
    }
  }

  /* ---------- 5. Cart drawer (T6.10 / T7.9 / T7.10) ---------- */

  // La seccion cart-drawer aporta el contenido editable del panel; el panel vive en
  // el layout. Aca se juntan, una sola vez, sin duplicar velo ni markup (T7.10 a).
  function mountCartExtra(drawer) {
    var extra = document.querySelector('[data-cart-extra]');
    if (!extra || extra.getAttribute('data-lab-bound')) return;
    extra.setAttribute('data-lab-bound', '1');
    var head = drawer.querySelector('.cart-dw__head');
    var foot = drawer.querySelector('[data-cart-foot]');
    var total = drawer.querySelector('.cart-dw__subtotal');
    var anchor = head;
    var afterTotal = total;
    var nodes = [];
    each(extra.children, function (n) { nodes.push(n); });
    for (var i = 0; i < nodes.length; i++) {
      var slot = nodes[i].getAttribute('data-cart-slot');
      // Datos (JSON) que ya se leyeron: se van con el contenedor.
      if (slot === 'data') continue;
      // Marca para poder reemplazarlo si el editor vuelve a renderizar la seccion.
      nodes[i].setAttribute('data-cart-mounted', '1');
      // Descuentos arriba del subtotal; tarjeta de cuotas debajo, en orden.
      if (slot === 'before-total' && total && total.parentNode) {
        total.parentNode.insertBefore(nodes[i], total);
        continue;
      }
      if (slot === 'after-total' && afterTotal && afterTotal.parentNode) {
        afterTotal.parentNode.insertBefore(nodes[i], afterTotal.nextSibling);
        afterTotal = nodes[i];
        continue;
      }
      // Upsell: al final del cuerpo con scroll (queda pegado arriba de descuentos
      // y subtotal). En el pie fijo empujaba "Pago seguro" fuera de la pantalla
      // en celulares bajos (360x640).
      if (slot === 'upsell') {
        var upBox = drawer.querySelector('[data-cart-upsell]');
        if (upBox) { upBox.appendChild(nodes[i]); continue; }
        if (foot) { foot.insertBefore(nodes[i], foot.firstChild); continue; }
      }
      if (slot === 'checkout') {
        // El texto del boton de pago sale del setting de la seccion.
        var checkout = drawer.querySelector('[data-cart-checkout]');
        if (checkout) { checkout.innerHTML = ''; checkout.appendChild(nodes[i]); }
        continue;
      }
      if (slot === 'foot' && foot) foot.appendChild(nodes[i]);
      else if (anchor && anchor.parentNode) {
        // Respeta el orden del Liquid: cada nodo va DESPUES del anterior.
        anchor.parentNode.insertBefore(nodes[i], anchor.nextSibling);
        anchor = nodes[i];
      }
    }
    extra.parentNode.removeChild(extra);
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;                       // sin markup global, el modulo sale temprano
    if (drawer.getAttribute('data-lab-bound')) return;
    drawer.setAttribute('data-lab-bound', '1');

    // Precio de comparacion por variante (cart.js no lo trae). Se lee ANTES de
    // montar: el contenedor de la seccion se borra al terminar.
    var compare = {};
    function readCompare() {
      var el = document.querySelector('[data-cart-compare]');
      if (!el) return;
      var m = {};
      try { m = JSON.parse(el.textContent) || {}; } catch (e) { m = {}; }
      for (var k in m) { if (m.hasOwnProperty(k)) compare[k] = m[k]; }
    }
    readCompare();
    var upIds = { v: 0, p: 0, img: '' };
    readUpsellIds();
    var compareLoading = {};
    var lastCart = null;

    mountCartExtra(drawer);

    var itemsEl = drawer.querySelector('[data-cart-items]');
    var emptyEl = drawer.querySelector('[data-cart-empty]');
    var footEl = drawer.querySelector('[data-cart-foot]');
    var subEl = drawer.querySelector('[data-cart-subtotal]');
    var countEl = drawer.querySelector('[data-cart-count]');
    var discEl = drawer.querySelector('[data-cart-discounts]');
    var discValEl = drawer.querySelector('[data-cart-discount]');

    // Productos que el comprador no tiene que ver (setting del theme): por
    // ejemplo, un producto auxiliar a $0 que no se vende por separado.
    var hidden = [];
    each((drawer.getAttribute('data-hidden-handles') || '').split(','), function (h) {
      h = h.replace(/\s+/g, '');
      if (h && h !== 'ejemplo-producto') hidden.push(h);
    });
    function isHidden(item) {
      for (var i = 0; i < hidden.length; i++) if (item.handle === hidden[i]) return true;
      return false;
    }

    function open() {
      if (drawer.className.indexOf('is-open') === -1) drawer.className += ' is-open';
      setExpanded(drawer, true);
      document.dispatchEvent(new CustomEvent('cart:opened'));
    }
    function close() {
      drawer.className = drawer.className.replace(/\s*is-open/g, '');
      setExpanded(drawer, false);
      if (pageStale()) reloadStale();
    }

    function setCounts(n) {
      if (countEl) countEl.textContent = n;
      var badge = document.querySelector('[data-cart-count-badge]');
      if (badge) { badge.textContent = n; badge.hidden = n === 0; }
    }

    function setDiscount(cents) {
      if (!discEl) return;
      discEl.hidden = !(cents > 0);
      if (discValEl) discValEl.textContent = '-' + money(cents);
    }

    // Variantes sin precio de comparacion conocido: se pide el .js de su producto
    // (una vez por producto) y se vuelve a pintar. Si falla, cuentan como 0.
    function loadCompare(items) {
      each(items, function (it) {
        var vid = String(it.variant_id);
        var url = String(it.url || '').split('?')[0];
        if (!url) { compare[vid] = 0; return; }
        if (compareLoading[url]) return;
        compareLoading[url] = true;
        fetch(url + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('product-js-failed'); return r.json(); })
          .then(function (p) {
            each(p.variants || [], function (v) { compare[String(v.id)] = v.compare_at_price || 0; });
          })
          .catch(function () {})
          .then(function () {
            each(items, function (x) {
              if (compare[String(x.variant_id)] === undefined) compare[String(x.variant_id)] = 0;
            });
            if (lastCart) render(lastCart);
          });
      });
    }

    // Upsell "un frasco mas": variante y producto salen de un dato de la seccion
    // que existe aunque la tarjeta este apagada. Solo cuenta como pack una linea
    // de ESE producto (asi el frasco nunca se cuelga de otro producto). Se lee
    // antes de montar, como el mapa de precios (upIds se declara arriba).
    function readUpsellIds() {
      var el = document.querySelector('[data-cart-upsell-ids]');
      upIds = { v: 0, p: 0, img: '' };
      if (!el) return;
      upIds.v = parseInt(el.getAttribute('data-variant-id'), 10) || 0;
      upIds.p = parseInt(el.getAttribute('data-product-id'), 10) || 0;
      upIds.img = el.getAttribute('data-image') || '';   // foto del editor (opcional)
    }
    // Lineas del upsell: las agrega este carrito con la propiedad oculta _upsell
    // (Shopify no la muestra en el checkout). Se reconocen por esa marca y no por
    // la variante: un pack comprado desde la pagina nunca se toma por el frasco,
    // aunque la posicion de variante del upsell este mal configurada.
    function isUpLine(it) { return !!(it && it.properties && it.properties._upsell); }
    // Pack = linea visible del producto del upsell que no es el frasco.
    function isPack(it) {
      if (isHidden(it) || isUpLine(it)) return false;
      if (upIds.v && it.variant_id === upIds.v) return false;
      return !upIds.p || it.product_id === upIds.p;
    }

    // Una linea del carrito. Las hijas (el upsell anidado a su pack) van debajo
    // del padre, corridas a la derecha y unidas con una rama (.cart-dw__branch).
    // more = hay otra hija debajo (el tronco de la rama sigue hasta ella).
    function lineHtml(e, child, hasKids, more) {
      var it = e.it;
      var line = e.line;
      var refLine = discEl ? e.ref * it.quantity : 0;
      // Nombre del pack (la variante): sin esto, dos packs distintos se ven iguales.
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      var who = esc(variant || it.product_title);
      // Cada boton apunta a la KEY de la linea (no a su posicion): si el carrito
      // se reordena mientras tanto (Shopify pone arriba lo ultimo agregado),
      // nunca se cambia otra linea. data-line queda para estilos y compatibilidad.
      var key = esc(it.key);
      var ins = it.instructions || {};
      // El frasco colgado del pack no tiene + / -: solo su X (pedido del cliente).
      var canQty = !child && ins.can_update_quantity !== false;
      var canRm = ins.can_remove !== false;
      var size = child ? 48 : 72;
      // El frasco usa la foto elegida en el editor, si hay (si no, la de Shopify).
      var img = isUpLine(it) && upIds.img ? upIds.img : it.image;
      return '<li class="cart-dw__item' + (child ? ' cart-dw__item--child' : '') + (hasKids ? ' cart-dw__item--parent' : '') + (more ? ' cart-dw__item--more' : '') + '" data-line="' + line + '" data-key="' + key + '">' +
        (child ? '<span class="cart-dw__branch" aria-hidden="true"></span>' : '') +
        (img ? '<img src="' + esc(img) + '" width="' + size + '" height="' + size + '" alt="">' : '') +
        '<span>' +
          (child
            ? '<span class="cart-dw__item-name">' + esc(variant || it.product_title) + '</span>' +
              '<span class="cart-dw__item-tag">Agregado a tu pack</span>'
            : '<span class="cart-dw__item-name">' + esc(it.product_title) + '</span>' +
              (variant ? '<span class="cart-dw__item-variant">' + esc(variant) + '</span>' : '')) +
          '<span class="cart-dw__item-meta">' +
            (refLine > it.final_line_price ? '<s>' + money(refLine) + '</s> ' : '') +
            money(it.final_line_price) + '</span>' +
          // Cantidad: restar (con 1 unidad, saca la linea) y sumar. Mismo hook
          // data-cart-qty que la cruz; data-qty es la cantidad final de la linea.
          (canQty
            ? '<span class="cart-dw__qty">' +
                '<button type="button" class="tap-44" data-cart-qty data-act="dec" data-key="' + key + '" data-line="' + line + '" data-qty="' + (it.quantity - 1) + '" aria-label="Restar una unidad de ' + who + ' (hay ' + it.quantity + ')">&minus;</button>' +
                '<span class="cart-dw__qty-n">' + it.quantity + '</span>' +
                '<button type="button" class="tap-44" data-cart-qty data-act="inc" data-key="' + key + '" data-line="' + line + '" data-qty="' + (it.quantity + 1) + '" aria-label="Sumar una unidad de ' + who + ' (hay ' + it.quantity + ')">+</button>' +
              '</span>'
            : '') +
        '</span>' +
        (canRm ? '<button type="button" class="cart-dw__remove tap-44" data-cart-qty data-act="rm" data-key="' + key + '" data-line="' + line + '" data-qty="0" aria-label="Quitar ' + who + ' del carrito">&times;</button>' : '') +
        '</li>';
    }

    // Respaldo del anidado de Shopify: si en el carrito quedan solo lineas del
    // upsell (sin ningun pack), se sacan solas. Asi nunca se compra el upsell solo.
    // Si hay un cambio en curso, la limpieza queda en espera y corre al liberar
    // (unlock). Dos intentos seguidos como maximo: si Shopify falla, no queda en
    // bucle; cada lectura que pide el comprador (abrir, agregar) da dos intentos
    // mas. Mientras el carrito tenga el frasco sin pack, el boton de pago no avanza.
    var pendingOrphans = null;
    var orphanTries = 0;
    var orphanLock = false;      // hay frasco del upsell y ningun pack
    var orphanBack = null;       // foco a restaurar cuando termine la limpieza
    function afterOrphans() { var b = orphanBack; orphanBack = null; unlock(b); }
    function flushOrphans() {
      var entries = pendingOrphans;
      pendingOrphans = null;
      if (!entries || !entries.length || orphanTries >= 2) return false;
      orphanTries += 1;
      changing = true;
      setBusy(true);
      var updates = {};
      each(entries, function (e) { updates[e.it.key] = 0; });
      fetch(cartUpdateUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { if (!r.ok) throw new Error('orphan-clean-failed'); return r.json(); })
        .then(function (cart) {
          render(cart);
          afterOrphans();
          // Pagina /cart: su form nativo manda updates[] por posicion; con una
          // linea menos quedaria desfasado. Se recarga (solo si quedo limpio).
          if (!orphanLock && document.querySelector('[data-cart-page]')) window.location.reload();
        })
        .catch(function () { return fetchCart().then(afterOrphans); });
      return true;
    }
    function removeOrphans(entries) {
      pendingOrphans = entries;
      if (!changing) flushOrphans();
    }

    function render(cart) {
      if (!itemsEl) return;
      lastCart = cart;
      var html = '';
      var visible = 0;
      var saved = cart.total_discount || 0;
      var missing = [];
      // Se agrupan las lineas: padres, hijas anidadas por Shopify
      // (parent_relationship.parent_key) y lineas del upsell sin anidar ("sueltas").
      // ups = todas las lineas del upsell; packs = cuantos packs hay.
      var parents = [], kids = {}, loose = [], ups = [];
      var packs = 0, firstPack = -1;
      var i;
      for (i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        // data-line sigue siendo la posicion REAL (1-based) aunque se salteen lineas.
        if (isHidden(it)) continue;
        visible += it.quantity;
        // Precio de referencia de la linea: el tachado si existe, si no el original.
        // Suma de referencias - Descuentos = Subtotal (cart.total_price).
        var ref = it.original_price;
        var cmp = compare[String(it.variant_id)];
        if (cmp === undefined) missing.push(it);
        else if (cmp > ref) { saved += (cmp - ref) * it.quantity; ref = cmp; }
        var entry = { it: it, line: i + 1, ref: ref };
        var pk = it.parent_relationship && it.parent_relationship.parent_key;
        var isUp = isUpLine(it);
        if (isUp) ups.push(entry);
        if (pk) { if (!kids[pk]) kids[pk] = []; kids[pk].push(entry); }
        else if (isUp) loose.push(entry);
        else {
          if (isPack(it)) { packs += 1; if (firstPack < 0) firstPack = parents.length; }
          parents.push(entry);
        }
      }
      var shown = {};
      for (i = 0; i < parents.length; i++) {
        var ks = kids[parents[i].it.key] || [];
        shown[parents[i].it.key] = true;
        // Upsell sin anidar (respaldo): se dibuja colgando del primer pack.
        if (i === firstPack) ks = ks.concat(loose);
        html += lineHtml(parents[i], false, ks.length > 0);
        for (var k = 0; k < ks.length; k++) html += lineHtml(ks[k], true, false, k < ks.length - 1);
      }
      // Hijas cuyo padre no esta visible (por ejemplo, un producto oculto): sueltas.
      for (var pkey in kids) {
        if (kids.hasOwnProperty(pkey) && !shown[pkey]) {
          for (var m = 0; m < kids[pkey].length; m++) html += lineHtml(kids[pkey][m], false, false);
        }
      }
      if (firstPack < 0) {
        for (i = 0; i < loose.length; i++) html += lineHtml(loose[i], false, false);
      }
      itemsEl.innerHTML = html;
      // Sin ningun pack, el upsell no se puede comprar solo: se saca (anidado o no,
      // por ejemplo si quedo colgado de otro producto).
      orphanLock = !packs && ups.length > 0;
      if (orphanLock) removeOrphans(ups);
      else { pendingOrphans = null; orphanTries = 0; }
      if (emptyEl) emptyEl.hidden = visible > 0;
      if (footEl) footEl.hidden = visible === 0;
      // El upsell vive al final del cuerpo (arriba de descuentos y subtotal) y se
      // esconde con el carrito vacio, igual que el pie. Sin pack tampoco se ofrece
      // (el frasco va siempre colgado de un pack).
      var upBox = drawer.querySelector('[data-cart-upsell]');
      if (upBox) upBox.hidden = visible === 0 || !packs || !upBox.firstElementChild;
      if (subEl) subEl.textContent = money(cart.total_price);
      setDiscount(saved);
      if (missing.length && discEl) loadCompare(missing);
      setCounts(visible);

      paintUpsell(cart);

      // T6.2: el HTML inyectado jamas lleva manejadores inline; se bindea por
      // data-* con addEventListener DESPUES de escribir el innerHTML.
      each(qsa(itemsEl, '[data-cart-qty]'), function (b) {
        b.addEventListener('click', function () {
          var q = parseInt(b.getAttribute('data-qty'), 10);
          if (isNaN(q) || q < 0) q = 0;
          // Teclado / lector de pantalla: al repintar, el foco vuelve al mismo boton.
          var back = document.activeElement === b
            ? '[data-key="' + b.getAttribute('data-key') + '"][data-act="' + b.getAttribute('data-act') + '"]'
            : null;
          changeLine({ id: b.getAttribute('data-key'), quantity: q }, back);
        });
      });
      // Si se repinta con un cambio en curso, los botones nuevos tambien quedan bloqueados.
      if (changing) setBusy(true);
    }

    // Un cambio por vez: mientras viaja el pedido, los botones del carrito se
    // desactivan (dos clicks rapidos no suman dos veces) y se liberan recien
    // DESPUES de pintar el carrito actualizado. Si falla, se relee el carrito real.
    var changing = false;
    function setBusy(on) {
      each(qsa(drawer, '[data-cart-qty], [data-cart-up-add]'), function (b) { b.disabled = on; });
    }
    // Solo candidatos que se ven: un boton dentro de un contenedor oculto no toma
    // el foco y el foco caeria en <body>, fuera del dialogo.
    function seen(el) { return el && (el.offsetWidth || el.offsetHeight) ? el : null; }
    function refocus(sel) {
      if (!sel) return;
      var t = seen(drawer.querySelector(sel)) || seen(itemsEl.querySelector('[data-cart-qty]')) ||
        seen(drawer.querySelector('[data-cart-up-add]:not([hidden])')) ||
        drawer.querySelector('.cart-dw__close');
      if (t && t.focus) t.focus();
    }
    function unlock(back) {
      changing = false;
      // Una limpieza de upsell huerfano en espera corre ahora (y libera al
      // terminar, devolviendo el foco a donde corresponde).
      if (pendingOrphans) {
        orphanBack = back;
        if (flushOrphans()) return;
        orphanBack = null;
      }
      setBusy(false);
      refocus(back);
      checkoutIfPending();
    }
    function changeLine(payload, back, url) {
      if (changing) return;
      changing = true;
      setBusy(true);
      fetch(url || cartChangeUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        // id = key de la linea (o id de variante). L-47: con line, 1-based.
        body: JSON.stringify(payload)
      })
        .then(function (r) { if (!r.ok) throw new Error('cart-change-failed'); return r.json(); })
        .then(function (cart) { render(cart); unlock(back); })
        .catch(function () { return fetchCart().then(function () { unlock(back); }); });
    }

    // Upsell "un frasco mas" (seccion cart-drawer, slot foot-top): el boton
    // Agregar suma 1 unidad de la variante elegida; si ya esta en el carrito,
    // queda la X para sacarla.
    function paintUpsell(cart) {
      var up = drawer.querySelector('[data-cart-up]');
      if (!up) return;
      var inCart = false;
      for (var k = 0; k < cart.items.length; k++) {
        if (isUpLine(cart.items[k])) inCart = true;
      }
      // Ya agregado, el boton desaparece (guarda su lugar) y queda el aviso; el
      // frasco se saca desde su linea, colgada del pack.
      var add = up.querySelector('[data-cart-up-add]');
      var ok = up.querySelector('[data-cart-up-ok]');
      if (add) add.hidden = inCart;
      if (ok) ok.hidden = !inCart;
      if (inCart) { if (up.className.indexOf('is-added') === -1) up.className += ' is-added'; }
      else up.className = up.className.replace(/\s*is-added/g, '');
    }
    function bindUpsell() {
      var up = drawer.querySelector('[data-cart-up]');
      if (!up || up.getAttribute('data-lab-bound')) return;
      up.setAttribute('data-lab-bound', '1');
      var vid = parseInt(up.getAttribute('data-variant-id'), 10);
      var add = up.querySelector('[data-cart-up-add]');
      // El pack al que se cuelga el frasco: la primera linea que sea un pack de
      // este producto y no sea hija (Shopify pone arriba lo ultimo agregado).
      function parentKey() {
        var items = lastCart ? lastCart.items : [];
        for (var p = 0; p < items.length; p++) {
          var it = items[p];
          if (it.variant_id === vid || !isPack(it)) continue;
          if (it.parent_relationship && it.parent_relationship.parent_key) continue;
          return it.key;
        }
        return null;
      }
      function post(item) {
        item.properties = { _upsell: '1' };     // marca oculta: ver isUpLine
        return fetch(cartAddUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function (r) {
          if (!r.ok) { var err = new Error('upsell-add-failed'); err.status = r.status; throw err; }
          return r.json();
        });
      }
      if (add) add.addEventListener('click', function () {
        if (changing || !vid) return;
        // Teclado: el foco pasa a la X de la linea del frasco recien agregado.
        var back = document.activeElement === add ? '.cart-dw__item--child [data-act="rm"]' : null;
        var pkey = parentKey();
        changing = true;
        setBusy(true);
        // Linea ANIDADA (nested cart line): Shopify la ordena debajo del pack y la
        // saca sola si se saca el pack. Si la tienda no lo admite (por ejemplo, con
        // Script Editor), se agrega como linea comun y el respaldo removeOrphans
        // evita que quede sola. Sin pack no se agrega nada.
        (pkey ? post({ id: vid, quantity: 1, parent_line_key: pkey }) : Promise.reject({ status: 0 }))
          .catch(function (err) {
            // Solo un rechazo de Shopify (4xx) asegura que no se agrego nada: ante
            // un corte de red o un 5xx no se reintenta (podria sumar 2 frascos).
            if (pkey && err && err.status >= 400 && err.status < 500) return post({ id: vid, quantity: 1 });
          })
          .catch(function () {})
          // Se pinta el carrito releido (lineas renumeradas) ANTES de liberar los botones.
          .then(fetchCart)
          .then(function () { unlock(back); });
      });
    }

    function fetchCart() {
      return fetch(cartUrl(), { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart-fetch-failed'); return r.json(); })
        .then(function (cart) { render(cart); return cart; })
        .catch(function () {});
    }
    // Lectura pedida por el comprador (abrir el carrito, agregar algo): la
    // limpieza del frasco huerfano vuelve a tener sus dos intentos.
    function userRead() { orphanTries = 0; return fetchCart(); }

    // Boton de pago: con el frasco del upsell y ningun pack no avanza (reintenta
    // la limpieza). Con un cambio en curso espera a que termine y recien ahi va
    // al pago (si el carrito quedo bien). El <a> vive en el layout: el listener
    // sobrevive al remount.
    var checkoutEl = drawer.querySelector('[data-cart-checkout]');
    var goCheckout = null;
    if (checkoutEl) checkoutEl.addEventListener('click', function (e) {
      if (!changing && !orphanLock) return;
      e.preventDefault();
      if (changing) { goCheckout = checkoutEl.href; return; }
      userRead();
    });
    function checkoutIfPending() {
      var h = goCheckout;
      goCheckout = null;
      if (h && !orphanLock && lastCart && lastCart.item_count > 0) window.location.href = h;
    }

    // Pagina /cart: su form nativo manda updates[] por posicion. Si el carrito
    // cambio desde este panel, el form quedo viejo: se recarga al cerrar el panel
    // y antes de enviarlo (compara variante y cantidad de cada posicion).
    var cartPage = document.querySelector('[data-cart-page]');
    function pageStale() {
      if (!cartPage || !lastCart) return false;
      var ins = qsa(cartPage, '[data-line-qty]');
      if (ins.length !== lastCart.items.length) return true;
      for (var i = 0; i < ins.length; i++) {
        var it = lastCart.items[i];
        if ((parseInt(ins[i].getAttribute('data-variant-id'), 10) || 0) !== it.variant_id) return true;
        if ((parseInt(ins[i].defaultValue, 10) || 0) !== it.quantity) return true;
      }
      return false;
    }
    // Recarga una sola vez cada 15 s: si por algo el form nunca coincide, no se
    // traba el envio en un bucle de recargas.
    function reloadStale() {
      var now = new Date().getTime();
      var last = 0;
      try { last = parseInt(window.sessionStorage.getItem('vlCartReload'), 10) || 0; } catch (err) {}
      if (now - last < 15000) return false;
      try { window.sessionStorage.setItem('vlCartReload', String(now)); } catch (err) {}
      window.location.reload();
      return true;
    }

    each(qsa(document, '[data-cart-close]'), function (el) {
      el.addEventListener('click', close);
    });

    each(qsa(document, '[data-cart-toggle], .site-header__cart'), function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();           // el href queda como fallback no-JS
        userRead();
        open();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      close();
    });

    document.addEventListener('cart:updated', function () { userRead(); });

    // T6.3: el editor re-renderiza la seccion cart-drawer; se reemplaza lo montado
    // con el contenido nuevo y se vuelve a pintar con el carrito actual.
    function remount() {
      each(qsa(drawer, '[data-cart-mounted]'), function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
      readCompare();
      readUpsellIds();
      mountCartExtra(drawer);
      discEl = drawer.querySelector('[data-cart-discounts]');
      discValEl = drawer.querySelector('[data-cart-discount]');
      bindUpsell();
      if (lastCart) render(lastCart); else fetchCart();
    }

    bindUpsell();

    // Pagina /cart (form nativo, sin este JS en el medio): si al enviar no queda
    // ningun pack, el frasco del upsell va en 0 en el mismo envio. Cubre
    // "Actualizar" e "Ir al pago". Con lineas anidadas Shopify ya lo hace solo.
    each(qsa(document, '[data-cart-page]'), function (f) {
      f.addEventListener('submit', function (e) {
        if (pageStale() && reloadStale()) { e.preventDefault(); return; }
        var packs = 0;
        var upInputs = [];
        each(qsa(f, '[data-line-qty]'), function (inp) {
          var it = {
            handle: inp.getAttribute('data-handle') || '',
            variant_id: parseInt(inp.getAttribute('data-variant-id'), 10) || 0,
            product_id: parseInt(inp.getAttribute('data-product-id'), 10) || 0,
            properties: inp.getAttribute('data-upsell') ? { _upsell: '1' } : null
          };
          if (isUpLine(it)) { upInputs.push(inp); return; }
          if (isPack(it) && (parseInt(inp.value, 10) || 0) > 0) packs += 1;
        });
        if (!packs) each(upInputs, function (inp) { inp.value = '0'; });
      });
    });

    NS.cart = { added: function () { userRead(); open(); }, refresh: userRead, open: open, close: close, remount: remount };

    fetchCart();
  }

  /* ---------- 6. Menu y buscador: un solo mecanismo de modal (7.12.4) ---------- */

  function initHeaderModals(scope) {
    var pairs = [
      ['[data-menu-open]', '[data-menu-panel]', '[data-menu-close]'],
      ['[data-search-open]', '[data-search-panel]', '[data-search-close]']
    ];
    for (var p = 0; p < pairs.length; p++) {
      (function (cfg) {
        var opener = (scope || document).querySelector(cfg[0]);
        var panel = document.querySelector(cfg[1]);
        var closer = panel ? panel.querySelector(cfg[2]) : null;
        if (!opener || !panel || opener.getAttribute('data-lab-bound')) return;
        opener.setAttribute('data-lab-bound', '1');

        function openP() {
          panel.className += ' is-open';
          setExpanded(panel, true);
          opener.setAttribute('aria-expanded', 'true');
        }
        function closeP() {
          panel.className = panel.className.replace(/\s*is-open/g, '');
          setExpanded(panel, false);
          opener.setAttribute('aria-expanded', 'false');
        }
        opener.addEventListener('click', openP);
        if (closer) closer.addEventListener('click', closeP);
        document.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape') return;
          closeP();
        });
      })(pairs[p]);
    }
  }

  /* ---------- 7. Carrusel de tarjetas: un unico componente (7.6.1) ---------- */

  function initCardCarousels(scope) {
    each(qsa(scope, '[data-mini-carousel]'), function (root) {
      if (root.getAttribute('data-lab-bound')) return;
      root.setAttribute('data-lab-bound', '1');

      var track = root.querySelector('[data-mini-track]');
      var prev = root.querySelector('[data-mini-prev]');
      var next = root.querySelector('[data-mini-next]');
      if (!track) return;

      // data-mini-loop (opcional, hoy solo las mini resenas del buy box): con una
      // tarjeta por vista, al llegar a un extremo la flecha vuelve al otro.
      var loop = root.hasAttribute('data-mini-loop');
      function step(dir) {
        var card = track.children[0];
        var w = card ? card.getBoundingClientRect().width + 14 : track.clientWidth;
        var max = track.scrollWidth - track.clientWidth;
        if (loop && dir > 0 && track.scrollLeft >= max - 2) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }
        if (loop && dir < 0 && track.scrollLeft <= 2) {
          track.scrollTo({ left: max, behavior: 'smooth' });
          return;
        }
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      // 7.6.8: iguala el alto del track al de la tarjeta mas alta, con debounce.
      // min-height (no height): si la fuente web carga despues de medir, la
      // tarjeta puede crecer y el texto no se corta ni se sale del borde.
      var t = null;
      function equalize() {
        if (t) clearTimeout(t);
        t = setTimeout(function () {
          var max = 0;
          each(track.children, function (c) {
            c.style.minHeight = '';
            if (c.offsetHeight > max) max = c.offsetHeight;
          });
          each(track.children, function (c) { c.style.minHeight = max + 'px'; });
        }, 80);
      }
      equalize();
      window.addEventListener('resize', equalize, { passive: true });
    });
  }

  /* ---------- 8. Reveal-on-scroll: UN solo observer (7.8) ---------- */

  function initReveal(scope) {
    var els = qsa(scope, '.reveal');
    if (!els.length) return;
    if (typeof IntersectionObserver === 'undefined') {
      // Sin observer los bloques nacen visibles, nunca en opacity:0 (7.0.1).
      each(els, function (el) { el.className += ' is-in'; });
      return;
    }
    var stickyH = 72;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        entries[i].target.className += ' is-in';
        io.unobserve(entries[i].target);
      }
    }, { threshold: 0.15, rootMargin: '0px 0px -' + (stickyH + 50) + 'px 0px' });

    each(els, function (el) {
      if (el.getAttribute('data-lab-bound')) return;
      el.setAttribute('data-lab-bound', '1');
      io.observe(el);
    });
  }


  /* ---------- 9. Timeline: rail con relleno progresivo (6.1.4 / 6.1.5) ---------- */

  // Revelado por scroll (pedido del cliente, oct 2026): UNA fase activa por vez
  // (o la actual y la siguiente con data-reveal="two"). La activa es la ultima
  // cuyo borde superior ya paso la linea de lectura (55% del alto de pantalla);
  // la primera se revela apenas asoma (90%). Antes de llegar, ninguna: el CSS
  // las oscurece. Cada tramo de la linea se rellena entre su circulo y el
  // siguiente siguiendo la misma linea de lectura.
  function initTimeline(scope) {
    each(qsa(scope, '[data-timeline]'), function (root) {
      if (root.getAttribute('data-lab-bound')) return;
      root.setAttribute('data-lab-bound', '1');

      var steps = root.querySelectorAll('[data-timeline-step]');
      if (!steps.length) return;
      var mode = root.getAttribute('data-reveal') || 'one';
      var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
      var queued = false;

      function setClass(el, name, on) {
        var has = (' ' + el.className + ' ').indexOf(' ' + name + ' ') !== -1;
        if (on && !has) el.className += ' ' + name;
        if (!on && has) el.className = el.className.replace(new RegExp('\\s*\\b' + name + '\\b', 'g'), '');
      }
      function nodeCenter(st) {
        var n = st.querySelector('[data-timeline-node]') || st;
        var r = n.getBoundingClientRect();
        return r.top + r.height / 2;
      }

      function paint() {
        queued = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var line = vh * 0.55;
        var active = -1;
        var i;
        for (i = 0; i < steps.length; i++) {
          if (steps[i].getBoundingClientRect().top <= line) active = i;
        }
        if (active === -1 && steps[0].getBoundingClientRect().top <= vh * 0.9) active = 0;

        for (i = 0; i < steps.length; i++) {
          var on = i === active || (mode === 'two' && active > -1 && i === active + 1);
          if (mode === 'off') on = i <= active;
          setClass(steps[i], 'is-active', on);
          setClass(steps[i], 'is-done', active > -1 && i < active);

          var seg = steps[i].querySelector('[data-timeline-seg]');
          if (seg && i + 1 < steps.length) {
            var a = nodeCenter(steps[i]);
            var b = nodeCenter(steps[i + 1]);
            var f = b > a ? (line - a) / (b - a) : 0;
            if (f < 0) f = 0;
            if (f > 1) f = 1;
            seg.style.height = (f * 100) + '%';
          }
        }
      }
      function queue() {
        if (queued) return;
        queued = true;
        raf(paint);
      }
      // Listeners passive: nunca recalcular cajas en cada frame sin passive (7.1.3).
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue, { passive: true });
      paint();
    });
  }

  /* ---------- 10. CTA intermedio: scroll al selector de packs (6.7.2) ---------- */

  function initScrollToPacks(scope) {
    each(qsa(scope, '[data-scroll-to-packs]'), function (btn) {
      if (btn.getAttribute('data-lab-bound')) return;
      btn.setAttribute('data-lab-bound', '1');
      btn.addEventListener('click', function () {
        var target = document.querySelector('[data-hp-bundles]');
        if (!target) { target = document.getElementById('AddToCartBtn'); }
        if (!target) return;                       // 11.2: jamas un ancla al top
        if (target.scrollIntoView) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          window.scrollTo(0, target.getBoundingClientRect().top + window.pageYOffset - 120);
        }
      });
    });
  }

  /* ---------- 11. Resenas masivas: mostrar mas (6.11.7, nunca scroll infinito) ---------- */

  function initReviewsMore(scope) {
    each(qsa(scope, '[data-reviews]'), function (root) {
      if (root.getAttribute('data-lab-bound')) return;
      root.setAttribute('data-lab-bound', '1');
      var btn = root.querySelector('[data-reviews-more]');
      if (!btn) return;
      var cards = root.querySelectorAll('[data-review-card]');
      function pending() {
        var n = 0;
        each(cards, function (c) { if (c.hidden) n++; });
        return n;
      }
      if (!pending()) { btn.hidden = true; return; }
      btn.addEventListener('click', function () {
        var shown = 0;
        for (var i = 0; i < cards.length && shown < 4; i++) {
          if (cards[i].hidden) { cards[i].hidden = false; shown++; }
        }
        if (!pending()) btn.hidden = true;
      });
    });
  }

  /* ---------- 12. Popup de captura (7.4) ---------- */

  function initPopup(scope) {
    var pop = (scope || document).querySelector('[data-popup]');
    if (!pop || pop.getAttribute('data-lab-bound')) return;
    pop.setAttribute('data-lab-bound', '1');

    var key = pop.getAttribute('data-storage-key') || 'venaless-popup';
    var delay = (parseInt(pop.getAttribute('data-popup-delay'), 10) || 12) * 1000;
    var autoclose = (parseInt(pop.getAttribute('data-popup-autoclose'), 10) || 15) * 1000;
    var closeTimer = null, openTimer = null, opened = false;

    // 7.0.1: sin sessionStorage el popup no se repite dentro de la misma carga.
    function dismissed() {
      try { return sessionStorage.getItem(key) === '1'; } catch (e) { return false; }
    }
    function remember() {
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
    }

    function cartIsOpen() {
      var dw = document.querySelector('[data-cart-drawer]');
      return !!(dw && dw.className.indexOf('is-open') !== -1);
    }

    function open() {
      if (opened || dismissed()) return;
      // Con el carrito abierto el popup taparia el boton de pago: espera.
      if (cartIsOpen()) { openTimer = setTimeout(open, 5000); return; }
      opened = true;
      pop.className += ' is-open';
      setExpanded(pop, true);
      closeTimer = setTimeout(close, autoclose);   // 7.4.9: autocierre
    }
    function close() {
      if (closeTimer) clearTimeout(closeTimer);
      pop.className = pop.className.replace(/\s*is-open/g, '');
      setExpanded(pop, false);
      remember();
    }

    if (dismissed()) return;

    openTimer = setTimeout(open, delay);
    // 7.4.2: o el primer click en el selector de packs, lo que ocurra primero.
    var packs = document.querySelector('[data-hp-bundles]');
    if (packs) {
      packs.addEventListener('click', function () {
        if (openTimer) clearTimeout(openTimer);
        open();
      }, { once: true });
    }

    each(qsa(pop, '[data-popup-close]'), function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      close();
    });
  }

  /* ---------- 13. Back-to-top (7.11.6) ---------- */

  function initBackToTop(scope) {
    var btn = (scope || document).querySelector('[data-back-to-top]');
    if (!btn || btn.getAttribute('data-lab-bound')) return;
    btn.setAttribute('data-lab-bound', '1');

    function onScroll() {
      var doc = document.documentElement.scrollHeight;
      var threshold = 0.4 * (doc - window.innerHeight);
      if (window.pageYOffset > threshold) {
        if (btn.className.indexOf('is-visible') === -1) btn.className += ' is-visible';
      } else {
        btn.className = btn.className.replace(/\s*is-visible/g, '');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    btn.addEventListener('click', function () {
      if (window.scrollTo) window.scrollTo({ top: 0, behavior: 'smooth' });
      else window.scrollTo(0, 0);
    });
  }

  /* ---------- 14. Alerta de stock: sigue al pack elegido (4.10) ---------- */

  function initStockAlert(scope) {
    each(qsa(scope, '[data-stock-alert]'), function (el) {
      if (el.getAttribute('data-lab-bound')) return;
      el.setAttribute('data-lab-bound', '1');
      // Con numero fijo declarado no hay nada que seguir.
      var source = el.getAttribute('data-stock-source');
      if (source !== 'real' && source !== 'auto') return;
      var max = parseInt(el.getAttribute('data-stock-max'), 10) || 0;
      var fixedN = parseInt(el.getAttribute('data-stock-fixed'), 10) || 0;
      var num = el.querySelector('[data-stock-n]');
      document.addEventListener('bundle:selected', function (e) {
        var raw = e.detail ? e.detail.stock : '';
        var n = raw === '' || raw === undefined ? NaN : parseInt(raw, 10);
        // "auto": la variante sin inventario controlado usa el numero fijo declarado.
        if (isNaN(n) && source === 'auto') n = fixedN;
        // 4.10.3: sin inventario real (ni numero de respaldo) la alerta no aparece.
        var show = !isNaN(n) && n > 0 && (!max || n <= max);
        el.hidden = !show;
        if (show && num) num.textContent = n;
      });
    });
  }

  /* ---------- 15. Countdown: UN solo modulo (T7.16 / T6.18) ---------- */

  function initCountdowns(scope) {
    each(qsa(scope, '[data-countdown]'), function (root) {
      if (root.getAttribute('data-lab-bound')) return;
      root.setAttribute('data-lab-bound', '1');
      var valueEl = root.querySelector('[data-countdown-value]');
      var daysEl = root.querySelector('[data-countdown-days]');
      if (!valueEl) return;
      var endIso = root.getAttribute('data-end');
      var minutes = parseInt(root.getAttribute('data-minutes'), 10) || 0;
      var key = root.getAttribute('data-storage-key');
      var end = 0, timer = null;

      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function readEnd() {
        try { return parseInt(sessionStorage.getItem(key), 10) || 0; } catch (e) { return 0; }
      }
      function saveEnd(v) {
        try { sessionStorage.setItem(key, String(v)); } catch (e) {}
      }
      function paint() {
        var left = Math.floor((end - new Date().getTime()) / 1000);
        if (left <= 0) {
          // Vencido no se reinicia: un minutero que vuelve a empezar es urgencia falsa.
          root.hidden = true;
          if (timer) clearInterval(timer);
          return;
        }
        var h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
        if (daysEl) { daysEl.textContent = Math.floor(h / 24); h = h % 24; }
        valueEl.textContent = (h > 0 ? pad(h) + ':' : '') + pad(m) + ':' + pad(s);
      }
      function start() {
        if (timer) return;
        if (endIso) {
          end = new Date(endIso).getTime();
        } else {
          // Minutero de reserva por sesion (T7.11 a): el fin se guarda una sola vez.
          end = readEnd();
          if (!end) { end = new Date().getTime() + minutes * 60000; saveEnd(end); }
        }
        root.hidden = false;
        paint();
        timer = setInterval(paint, 1000);
      }

      if (root.getAttribute('data-countdown-start') === 'cart-open') {
        document.addEventListener('cart:opened', start);
        if (!endIso && readEnd()) start();
      } else {
        start();
      }
    });
  }

  /* ---------- 16. Videos: arrancan muteados y el toque activa el sonido ---------- */

  function initVideoCards(scope) {
    each(qsa(scope, '[data-video-card]'), function (card) {
      if (card.getAttribute('data-lab-bound')) return;
      card.setAttribute('data-lab-bound', '1');
      var video = card.querySelector('video');
      var btn = card.querySelector('[data-video-sound]');
      if (!video || !btn) return;
      btn.addEventListener('click', function () {
        // Un solo video con sonido a la vez.
        each(qsa(document, '[data-video-card] video'), function (v) {
          if (v !== video) {
            v.muted = true;
            var other = closestAttr(v, 'data-video-card');
            if (other) other.className = other.className.replace(/\s*is-sound/g, '');
          }
        });
        video.muted = !video.muted;
        if (!video.muted && video.play) video.play();
        card.className = card.className.replace(/\s*is-sound/g, '') + (video.muted ? '' : ' is-sound');
        btn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
      });
    });
  }

  /* ---------- Dispatcher idempotente (T6.3) ---------- */

  function initScope(scope) {
    initGallery(scope);
    initProductForm(scope);
    initStickyAtc(scope);
    initHeaderModals(scope);
    initCardCarousels(scope);
    initTimeline(scope);
    initScrollToPacks(scope);
    initReviewsMore(scope);
    initPopup(scope);
    initBackToTop(scope);
    initStockAlert(scope);
    initCountdowns(scope);
    initVideoCards(scope);
    initReveal(scope);
  }
  NS.initScope = initScope;

  function boot() {
    initCartDrawer();      // global: vive en el layout, se inicializa una sola vez
    initScope(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // La Section Rendering API reemplaza el nodo SIN disparar DOMContentLoaded (L-52).
  document.addEventListener('shopify:section:load', function (e) {
    // Primero initScope: enlaza el minutero nuevo mientras sigue dentro de la seccion.
    initScope(e.target);
    if (e.target.querySelector('[data-cart-extra]') && NS.cart && NS.cart.remount) NS.cart.remount();
  });
})();
